/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_S2_Li5Inputs */

const en_guide_json_schema_s2_li5 = /** @type {(inputs: Guide_Json_Schema_S2_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>enum</strong>: Restricts a value to a fixed set of options`)
};

const ko_guide_json_schema_s2_li5 = /** @type {(inputs: Guide_Json_Schema_S2_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>enum</strong>: 값을 고정된 옵션 세트로 제한`)
};

const ja_guide_json_schema_s2_li5 = /** @type {(inputs: Guide_Json_Schema_S2_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>enum</strong>: 値を固定の選択肢に制限`)
};

/**
* | output |
* | --- |
* | "<strong>enum</strong>: Restricts a value to a fixed set of options" |
*
* @param {Guide_Json_Schema_S2_Li5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_s2_li5 = /** @type {((inputs?: Guide_Json_Schema_S2_Li5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_S2_Li5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_s2_li5(inputs)
	if (locale === "ko") return ko_guide_json_schema_s2_li5(inputs)
	return ja_guide_json_schema_s2_li5(inputs)
});